import React, { memo, useEffect } from 'react';
import { AIResultsPageProps } from './types';
import { generateID } from '../../base/helper';
import loadingAI from '../../assets/videos/ai-loader.mp4';

const Body: React.FC<AIResultsPageProps> = ({
  id = generateID('clientos-ui-toolkit-ai-results-page-body'),
  children,
  loading = false
}) => {
  useEffect(() => {
    Array.from<Element>(
      document.getElementsByClassName(
        'clientos-ui-toolkit-ai-results-page__body__accordion'
      )
    ).forEach((item, index) => {
      item.setAttribute('style', `--delay-time: ${index * 0.5}s`);
    });
  }, []);
  return (
    <div
      className={`clientos-ui-toolkit-ai-results-page__body${loading ? ' clientos-ui-toolkit-ai-results-page__body--loading' : ''}`}
      id={id}
    >
      {children}
      {loading && (
        <div
          className="clientos-ui-toolkit-ai-results-page__body__loader"
          id={`${id}__body__loader`}
        >
          <video
            id={`${id}__body__loader__video`}
            className="clientos-ui-toolkit-ai-results-page__body__loader__video"
            autoPlay
            loop
            muted
            disablePictureInPicture
          >
            <source
              src={loadingAI}
              type="video/mp4"
            />
          </video>
        </div>
      )}
    </div>
  );
};

export default memo(Body);
